import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Header';
import Hero from './Hero';
import About from './About';
import Patterns from './Patterns';
import Services from './Services';
import Contact from './Contact';
import Footer from './Footer';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <div className="App">
            <Header />
            <main>
              <Hero />
              <About />
              <Patterns />
              <Services />
              <Contact />
            </main>
            <Footer />
          </div>
        } />

      </Routes>
    </Router>
  );
}

export default App;